import { ReactNode } from "react";

import { JotaiProvider } from "./JotaiProvider";
import { MSALProvider } from "./MSALProvider";
import { MuiDateLocalizationProvider } from "./MuiDateLocalizationProvider";
import { MuiProvider } from "./MuiProvider";
import { ReduxPersistProvider } from "./ReduxPersistProvider";
import { ReduxProvider } from "./ReduxProvider";
import { TanstackQueryProvider } from "./TanstackQueryProvider";
import { StyledComponentProvider } from "./StyledComponentProvider";
import { ScrollManagement } from "../wrappers/ScrollManagement";
import { PopoverContainerContextProvider } from "../../stories/core-ui/components/BasePopover/PopoverContainerContext";
import { GoogleAuthProvider } from "./GoogleAuthProvider";
import { PayPalProvider } from "./PayPalProvider";

export const AllProviders = ({ children }: { children: ReactNode }) => {
  return (
    <JotaiProvider>
      <ReduxProvider>
        <MSALProvider>
          <ReduxPersistProvider>
            <TanstackQueryProvider>
              {/*  Mui Provider uses a jotai atom, and must be located under the JotaiProvider */}
              <MuiProvider>
                <MuiDateLocalizationProvider>
                  <StyledComponentProvider>
                    {/*  While ScrollManagement is not a provider, it was put at this spot before conversion.*/}
                    {/*  This comment may be deleted when we can safely (re)move this element */}
                    <ScrollManagement>
                      <PopoverContainerContextProvider>
                        <GoogleAuthProvider>
                          <PayPalProvider>{children}</PayPalProvider>
                        </GoogleAuthProvider>
                      </PopoverContainerContextProvider>
                    </ScrollManagement>
                  </StyledComponentProvider>
                </MuiDateLocalizationProvider>
              </MuiProvider>
            </TanstackQueryProvider>
          </ReduxPersistProvider>
        </MSALProvider>
      </ReduxProvider>
    </JotaiProvider>
  );
};
